// Viewport height fix for mobile browsers
(function() {
  let resizeTimeout;
  function setVH() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
  }
  function debouncedSetVH() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(setVH, 100);
  }
  window.addEventListener('resize', debouncedSetVH);
  setVH();
})();
